import type { Msg, Session } from '@halo/chat-sdk-react';
import {
  ItemExpireContext as MessageExpireContext,
  MessageFile,
  MessageMetaRoot,
} from '@halo/ui-chat-react';
import { Center } from '@chakra-ui/react';
import { useStaticAppStore } from '@/store/client';
import { Emoji } from '@/components/Emoji';
import {
  MsgAvatar,
  MsgBody,
  MsgBubble,
  MsgExpireAnimate,
  MsgFooter,
  MsgFooterReplies,
  MsgForwardFrom,
  MsgHeader,
  MsgItem,
  MsgMenuTrigger,
  MsgReadStatus,
  MsgReply,
} from '../../msg-parts';

export interface MsgFileProps {
  session: Session;
  message: Msg;
}

export const MsgFile = memo(function MsgFile({ session, message }: MsgFileProps) {
  const appStore = useStaticAppStore();
  const sessionStore = appStore.sessionStores[session.chat_id];

  const onAbort = useCallback(() => {
    sessionStore?.getState().cancelFile(message.cli_msg_id);
  }, [sessionStore, message]);

  return (
    <MsgItem message={message}>
      <MessageExpireContext message={message}>
        <MsgAvatar message={message} session={session} />
        <MsgBody message={message}>
          <MsgHeader message={message} session={session} />
          <MsgMenuTrigger message={message}>
            <MsgExpireAnimate session={session} message={message}>
              <MsgBubble message={message}>
                {message.msg_ext?.forwardUid && (
                  <MsgForwardFrom forwardUid={message.msg_ext.forwardUid} />
                )}
                {message.link_msg_id && (
                  <MsgReply session={session} link_msg_id={message.link_msg_id} />
                )}
                <MessageFile
                  message={message}
                  onAbort={onAbort}
                  sessionStore={sessionStore}
                ></MessageFile>
                <MessageMetaRoot>
                  <Emoji.MessageMeta chat_id={session.chat_id} message={message} />
                  <Center marginLeft="auto" gap="1.5">
                    <MsgReadStatus message={message} session={session} />
                  </Center>
                </MessageMetaRoot>
              </MsgBubble>
            </MsgExpireAnimate>
          </MsgMenuTrigger>
          <MsgFooter message={message}>
            <MsgFooterReplies message={message} />
          </MsgFooter>
        </MsgBody>
      </MessageExpireContext>
    </MsgItem>
  );
});
